import { defineComponent } from 'vue';
import { mapGetters } from 'vuex';
import imageGalleryDesktopSlider from '@/components/Blue/ProductDetailPage/Modules/ImageGalleryDesktopSlider.vue';
export default defineComponent({
    name: 'image-gallery-desktop',
    components: {
        imageGalleryDesktopSlider,
    },
    computed: Object.assign(Object.assign({}, mapGetters('blue', {
        currentProduct: 'currentProduct',
    })), mapGetters('global', {
        isMobile: 'isMobile',
    })),
});
